import React from 'react'
import FormComponent from '../components/formComponent';
import { renderReport } from '../components/elementList';

class UiFieldEntity extends React.Component {

    static defaultProps = {
        finished: (fieldEntityReport) => { },
        error: (error) => { },
        services: {
            asset: {},
            customer: {}
        },
        customer: {},
        field: {},
        type: {
            name: "",
            fixedPre: '',
            fixedPost: '',
        }
    }
    constructor(props) {
        super(props);

        this.assetService = props.services.asset;
        this.customerService = props.services.customer;

        // this.stepManagerRef = createRef();

        this.state = {
            assetEntity: null,
            finished: false,
        }
    }

    reportAllComponentData = () => {
        let { assetEntity } = this.state;
        let { name } = this.props.type;

        if ((!assetEntity) || (!name)) {
            return null;
        }

        let data = [
            { key: 'ENTITY ' + name.toUpperCase() + ' ID', value: assetEntity.id.id },
            { key: 'ENTITY ' + name.toUpperCase() + ' NAME', value: assetEntity.name },
            { key: 'ENTITY ' + name.toUpperCase() + ' TYPE', value: assetEntity.type }
        ];
        return data;
    }

    handleValidate = (values) => {
        const errors = {};
        if (!values.name) {
            errors.name = 'Required';
        }
        return errors;
    };

    handleSubmitError = (error) => { this.props.error(error); };

    addEntityToCustomer = (entityId, customerId) => {
        return this.customerService.addEntityToCustomerRelation(entityId, customerId).then(() => {
            return this.customerService.assignEntityToCustomer(entityId, customerId);
        });
    }

    handleFieldEntitySubmit = (values) => {
        let { customer, field, type } = this.props;

        values.name = values.name ? values.name : type.fixedPre.toUpperCase() + field.name;
        values.type = values.type ? values.type : field.type + type.fixedPost.toLowerCase();

        return this.assetService.addAssetEntity(values, field.id.id).then((response) => {
            let fieldEntity = response;
            this.setState({ assetEntity: response });

            return this.addEntityToCustomer(fieldEntity.id.id, customer.id).then(() => {
                this.setState({ finished: true });
                this.props.finished(fieldEntity, this.reportAllComponentData());
            });
        }).catch(this.handleSubmitError);
    };

    renderFieldEntityForm = () => {
        let { customer, field, type } = this.props;

        return (
            <div>
                <FormComponent
                    initialValues={{
                        name: `${type.fixedPre}${field.name}`,
                        type: `${field.type}${type.fixedPost}`,
                        customer: customer.name
                    }}
                    validateFunc={this.handleValidate}
                    submitFunc={this.handleFieldEntitySubmit}
                    inputs={[
                        { key: 'name', type: 'text', inputType: 'input', placeholder: 'Name', label: 'Name', disabled: true },
                        { key: 'type', type: 'text', inputType: 'input', placeholder: 'Type', label: 'Type', disabled: true },
                        { key: 'customer', type: 'text', inputType: 'input', placeholder: type.name.toLowerCase(), label: `${type.name} Customer`, disabled: true },
                    ]}
                />
            </div>
        );
    };
    render() {
        let { finished } = this.state;
        if (finished) {
            return renderReport(this.reportAllComponentData());
        }
        else {
            return this.renderFieldEntityForm();
        }
    }
}


export default UiFieldEntity;